import React from 'react';
import cx from 'clsx';
import { getImage } from 'gatsby-plugin-image';
import featureQuery from '../../query/featureQuery';
import ProductBlock from '../ProductBlock';
import Hr from '../Hr';
import * as themeStyles from '../../assets/theme.module.scss';
import { sendEvent } from '../../utils/ga';

const FeatureProduct = () => {
    const feaureProducts = featureQuery();
    const handleClick = (label) => {
        sendEvent('Home Feature Product', 'click', label);
    }
    return (
        <section className={cx(themeStyles.py8, themeStyles.pyMd11, themeStyles.bgGray200)}>
            <div className={themeStyles.container}>
                <h2 className={themeStyles.textSmCenter}>特色產品</h2>
                <Hr />
                <div className={cx(themeStyles.dMdBlock)}>
                    <ul className={cx(themeStyles.row, 'reset')}>
                        {feaureProducts.map((product) => {
                            const categoryUrl = product.category[0].url;
                            const { url, name } = product;
                            const { images } = product;
                            return (
                                <li className={cx(themeStyles.col12, themeStyles.colMd6, themeStyles.colLg4, themeStyles.mb6)} key={url}>
                                    <ProductBlock
                                        link={`/products/${categoryUrl}/${url}`}
                                        title={name}
                                        image={getImage(images[0])}
                                        onClick={() => handleClick(name)}
                                    />
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default FeatureProduct;
